
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/basic.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/opt/buildhome/repo/packages/x/docs/x-sdk/demos/x-conversations/basic.md?type=demo')
};